
import { useEffect } from 'react';
import { useAppDispatch } from '../../store/store';

export const RefreshTokenTrigger = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch({ type: 'START_REFRESH_TIMER' });

        return () => {
            
        };
    }, [dispatch]);

    return null;
};

